import "./blog.css";

export default function BlogHero() {
  return (
    <section className="blog-hero">
      <div className="blog-hero-blob" aria-hidden="true" />
      <div className="blog-hero-dots blog-hero-dots--a" aria-hidden="true" />
      <div className="blog-hero-dots blog-hero-dots--b" aria-hidden="true" />

      <div className="blog-hero-inner">
        <div className="blog-hero-copy">
          <p className="blog-eyebrow">OUR BLOG</p>
          <h1 className="blog-hero-title">
            Insights That <span>Empower Growth</span>
          </h1>
          <p className="blog-hero-lead">
            Stay informed with the latest articles, news and expert insights on
            investing, loans, wealth management, and financial planning.
          </p>
        </div>

        <div className="blog-hero-visual">
          <img
            src="/images/blog-hero-desk.png"
            alt="Notebook, coffee, and plant on a desk"
            className="blog-hero-img"
          />
        </div>
      </div>
    </section>
  );
}
